var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prebilled-amount"},[_c('v-alert',{attrs:{"dense":"","outlined":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.$t("prebilled." + _vm.mode + ".text"))+" "),_c('strong',[_vm._v(" "+_vm._s(_vm.$n(_vm.prebilledAmount, "currency"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }